import { render, staticRenderFns } from "./questionPaperEvaluationSchemePreview.vue?vue&type=template&id=8f981f06"
import script from "./questionPaperEvaluationSchemePreview.vue?vue&type=script&lang=js"
export * from "./questionPaperEvaluationSchemePreview.vue?vue&type=script&lang=js"
import style0 from "./questionPaperEvaluationSchemePreview.vue?vue&type=style&index=0&id=8f981f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports